module.exports = __webpack_public_path__ + "static/media/alert_4.b883bd49.svg";